
import {Component, Vue, Prop} from 'vue-property-decorator';
import aiConfigList from '@/js/aiConfig/aiconfig-list.helper';
import {AIMonitorApi} from '@/api';
import moment from 'moment';
import * as echarts from 'echarts';
import Empty from '@/components/Empty/index.vue';

@Component({
    components: {
        Empty
    }
})
export default class UsageStatistics extends Vue {
    @Prop({default: false}) isClass!: string;
    @Prop({default: () => []}) schoolParams!: Array<string>;
    searchQuery = {AIability: 'fr', customizeTime: []};
    usageList = aiConfigList.aiConfigItem;
    aiConfigObj = aiConfigList.aiConfigObj;
    time = 'month';
    fromTime = '';

    XAixs = {};
    isSameDay = false;
    onChangeAbility() {
        this.getData();
    }
    onchangeTime(val: any) {
        this.searchQuery.customizeTime = [];
        if (val.target.value === 'year') {
            this.XAixs = this.getMonths(12);
        } else if (val.target.value === 'month') {
            this.XAixs = this.getDays(30);
            this.time = 'month';
        } else if (val.target.value === 'halfYear') {
            this.XAixs = this.getMonths(6);
        } else {
            this.XAixs = this.getDays(7);
        }
        this.getData();
    }
    customizeChangeTime() {
        if (Math.abs(moment(this.searchQuery.customizeTime[0]).diff(moment(this.searchQuery.customizeTime[1]), 'day')) > 730) {
            this.$message.warning('最大时间范围不能超过730天');
            return;
        }
        if (this.searchQuery.customizeTime.length) {
            this.time = '';
            this.isSameDay = moment(this.searchQuery.customizeTime[0]).isSame(this.searchQuery.customizeTime[1]);
            if (this.isSameDay) {
                this.getUsageData();
            } else {
                this.getData();
            }
        } else {
            this.time = 'month';
            this.isSameDay = false;
            this.onchangeTime({target: {value: 'month'}});
        }
    }

    getData() {
        this.getUsageData();
    }

    chart = {};
    option = {};
    initChart() {
        const chartDom: null | HTMLElement = document.querySelector('#chart');
        if (chartDom) {
            this.chart = echarts.init(chartDom, undefined, {renderer: 'svg'});
            this.option = {
                title: [
                    {
                        text: '使用统计',
                        left: -5,
                        textStyle: {
                            fontWeight: 500,
                            fontSize: 14,
                            color: 'rgba(0,0,0,0.9)'
                        }
                    },
                    {
                        text: `单位：${this.searchQuery.AIability === 'asr-rt' ? '分钟' : '次'}`,
                        left: 60,
                        textStyle: {
                            fontWeight: 400,
                            fontSize: 14,
                            color: 'rgba(0,0,0,0.4)'
                        }
                    }
                ],
                tooltip: {
                    trigger: 'axis',
                    formatter: (params: any) => {
                        const data = params[0];
                        const value = this.searchQuery.AIability === 'asr-rt' ? this.formatMsTime(data.data[2]) || 0 : data.data[1] + '次';
                        const result = `<div style="margin-bottom:8px">${data.data[0].replace(
                            /-/g,
                            '/'
                        )}</div><div style="margin-bottom:4px;">${
                            data.seriesName
                        }</div><div><span style="color:#999">总计： </span>${value}</div>`;
                        return result;
                    }
                },
                grid: {
                    left: 16,
                    top: 48,
                    right: 8,
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    axisTick: {
                        show: true,
                        alignWithLabel: true
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: '#DCDEE0'
                        }
                    },
                    axisLabel: {
                        show: true,
                        color: 'rgba(0,0,0,0.6)',
                        showMinLabel: true,
                        margin: 24,
                        formatter: (val: string) => {
                            if (!this.isSameDay) {
                                return moment(val).format('YYYY/MM/DD');
                            } else {
                                return val;
                            }
                        }
                    }
                },
                yAxis: [
                    {
                        type: 'value',
                        axisLabel: {
                            color: 'rgba(0,0,0,0.6)'
                        },
                        splitNumber: 5,
                        max: () => {
                            if (this.autoMax) {
                                return this.searchQuery.AIability !== 'asr-rt' ? 10 : 5;
                            } else {
                                return null;
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.aiConfigObj[this.searchQuery.AIability],
                        type: 'line',
                        stack: 'Total',
                        symbol: this.isSameDay ? 'auto' : 'none',
                        areaStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {offset: 0, color: 'rgba(41,85,228,0.25)'},
                                {offset: 0.5, color: 'rgba(41,85,228,0.15)'},
                                {offset: 1, color: 'rgba(41,85,228,0)'}
                            ])
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.histogramData
                    }
                ]
            };
            this.$nextTick(() => {
                (this.chart as echarts.ECharts).resize();
            });
            (this.chart as any).setOption(this.option);
            window.addEventListener('resize', () => {
                (this.chart as any).resize();
            });
        }
    }

    usageInfo: {amount: number; schoolsUsage: number | string; mostUseSchool: string} = {
        amount: 0,
        schoolsUsage: 0,
        mostUseSchool: '暂无'
    };
    histogramData = [];
    rankList: any = [];
    getUsageData() {
        console.log(this.isClass);
        const url = this.isClass
            ? `/ecode/statistics/usage/histogram/class/${this.schoolParams[1]}/bystudent`
            : `/ecode/statistics/usage/histogram/school/${this.schoolParams[0]}/byclass`;
        AIMonitorApi.getUsageStatisticsData({
            context: this,
            url,
            data: {
                type: this.searchQuery.AIability,
                from: this.time ? this.fromTime : moment(this.searchQuery.customizeTime[0]).format('YYYY-MM-DD 00:00:00'),
                to: this.time
                    ? moment().format('YYYY-MM-DD 24:00:00')
                    : moment(this.searchQuery.customizeTime[1]).format('YYYY-MM-DD 24:00:00')
            },
            success: (data: any) => {
                if (data.code === 0) {
                    const usageData = data.data;
                    if (usageData.length) {
                        this.usageInfo = {
                            amount: usageData.reduce((pre: any, cur: {amount: any}) => {
                                return pre + cur.amount;
                            }, 0),
                            schoolsUsage: usageData[0].name,
                            mostUseSchool: usageData[0].name || usageData[0].nickname
                        };
                        this.rankList = usageData.splice(0, 6);
                    } else {
                        this.usageInfo = {amount: 0, schoolsUsage: '暂无', mostUseSchool: '暂无'};
                        this.rankList = [];
                    }
                    if (this.isSameDay) {
                        this.getDataByHour();
                    } else {
                        this.getHistogramData();
                    }
                    if (!this.isClass) {
                        this.getStudentRankList();
                    }
                }
            }
        });
    }
    autoMax: any = true;
    getHistogramData() {
        let url = this.isClass
            ? `/ecode/statistics/usage/histogram/class/${this.schoolParams[1]}/bydate`
            : `/ecode/statistics/usage/histogram/school/${this.schoolParams[0]}/bydate`;
        AIMonitorApi.getHistogramStatisticsData({
            context: this,
            url,
            data: {
                type: this.searchQuery.AIability,
                from: this.time ? this.fromTime : moment(this.searchQuery.customizeTime[0]).format('YYYY-MM-DD 00:00:00'),
                to: this.time
                    ? moment().format('YYYY-MM-DD 24:00:00')
                    : moment(this.searchQuery.customizeTime[1]).format('YYYY-MM-DD 24:00:00')
            },
            success: (data: any) => {
                if (data.code === 0) {
                    if (data.data.length) {
                        this.histogramData = data.data.map((item: {date: any; amount: any}) => {
                            return [
                                moment(item.date).format('YYYY-MM-DD'),
                                this.searchQuery.AIability === 'asr-rt' ? item.amount / 1000 / 60 : item.amount,
                                item.amount
                            ];
                        });
                    } else {
                        this.histogramData = [];
                    }
                    const maxData = this.histogramData.map(item => item[1]);
                    const maxCount = this.searchQuery.AIability === 'asr-rt' ? 5 : 10;
                    if (Math.max(...maxData) <= maxCount) {
                        this.autoMax = true;
                    } else {
                        this.autoMax = false;
                    }

                    this.$nextTick(() => {
                        this.initChart();
                    });
                }
            }
        });
    }
    getDataByHour() {
        AIMonitorApi.getHistogramStaticsDataByHour({
            context: this,
            schoolId: this.schoolParams[0],
            data: {
                type: this.searchQuery.AIability,
                date: moment(this.searchQuery.customizeTime[0]).format('YYYY-MM-DD 00:00:00')
            },
            success: (data: any) => {
                if (data.code === 0) {
                    if (data.data.length) {
                        this.histogramData = data.data.map((item: {date: any; amount: any}) => {
                            return [
                                moment(item.date).format('HH:00'),
                                this.searchQuery.AIability === 'asr-rt' ? item.amount / 1000 / 60 : item.amount,
                                item.amount
                            ];
                        });
                    } else {
                        this.histogramData = [];
                    }
                    const maxData = this.histogramData.map(item => item[1]);
                    const maxCount = this.searchQuery.AIability === 'asr-rt' ? 5 : 10;
                    if (Math.max(...maxData) <= maxCount) {
                        this.autoMax = true;
                    } else {
                        this.autoMax = false;
                    }
                    this.$nextTick(() => {
                        this.initChart();
                    });
                }
            }
        });
    }
    getStudentRankList() {
        AIMonitorApi.getStudentRankList({
            context: this,
            schoolId: this.schoolParams[0],
            data: {
                type: this.searchQuery.AIability,
                from: this.time ? this.fromTime : moment(this.searchQuery.customizeTime[0]).format('YYYY-MM-DD 00:00:00'),
                to: this.time
                    ? moment().format('YYYY-MM-DD 24:00:00')
                    : moment(this.searchQuery.customizeTime[1]).format('YYYY-MM-DD 24:00:00')
            },
            success: (data: any) => {
                if (data.code === 0) {
                    if (data.data.length) {
                        this.usageInfo.mostUseSchool = data.data[0].nickname;
                    }
                }
            }
        });
    }
    formatDateType = '';
    getDays(day: number) {
        const dates = [];
        const NUM_OF_DAYS = day;
        this.formatDateType = 'day';
        this.fromTime = moment()
            .subtract(day - 1, 'day')
            .format('YYYY-MM-DD 00:00:00');
        for (let i = 0; i < NUM_OF_DAYS; i++) {
            const date = moment().subtract(i, 'day').format('YYYY-MM-DD');
            dates.push({value: date});
        }
        return dates.reverse();
    }
    getMonths(month: number) {
        const dates = [];
        const NUM_OF_MONTHS = month;
        this.formatDateType = 'month';
        this.fromTime = moment()
            .subtract(month - 1, 'month')
            .format('YYYY-MM-DD 00:00:00');
        for (let i = 0; i < NUM_OF_MONTHS; i++) {
            const date = moment().subtract(i, 'month').format('YYYY-MM');
            dates.push({value: date});
        }
        return dates.reverse();
    }

    formatMsTime(time: string) {
        const days = moment.duration(time).days() ? moment.duration(time).days() : 0;
        const hour = moment.duration(time).hours() ? days * 24 + moment.duration(time).hours() + '时' : '';
        const min = moment.duration(time).minutes() ? moment.duration(time).minutes() + '分' : '';
        const second = moment.duration(time).seconds() ? moment.duration(time).seconds() + '秒' : '';
        return hour + min + second ? hour + min + second : 0;
    }

    mounted() {
        this.time = 'month';
        this.$nextTick(() => {
            this.initChart();
        });
    }
}
